import {GetHealthSpecialtyAuthorizationParams} from 'domain/usecases';
import {makeGetHealthSpecialtyAuthorization} from 'main/factories/usecases';

export async function getHealthSpecialtyAuthorization(
	params: GetHealthSpecialtyAuthorizationParams,
) {
	const response = await makeGetHealthSpecialtyAuthorization().get(params);

	if ('content' in response) return response;

	return {
		content: {
			specialtyAuthorization: response.autorizaAgendamento,
			specialtyCode: Number(params.speciality),
			appointmentPasswordFlag: false,
			forwardSpecialty: false,
			historyOfScheduledAppointments: false,
			smartScheduleSpecialty: false,
			suggestedSpecialties: [],
		},
	};
}
